export default "__VITE_ASSET__a3861966__"